import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { InvoiceService } from 'src/app/services/invoice.service';
import { StoreService } from 'src/app/services/store.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-dnit-inutilizacion',
  templateUrl: './dnit-inutilizacion.component.html',
  styleUrls: ['./dnit-inutilizacion.component.scss'],
  providers: [InvoiceService, StoreService, UtilsService]
})
export class DnitInutilizacionComponent implements OnInit {
  public loading = false;

  public userCode: number;
  public storeCode: number;
  public establecimiento: string = '';

  public punto: string = '';
  public desde: string = '';
  public hasta: string = '';
  public tipoDocumento: string = 'FACT';
  public motivo: string = '';
  public serie: string = '';

  public resultMessage: string = '';
  public signedEventXml: string = '';
  public dnitResponseRaw: string = '';
  private lastRangeLabel: string = '';

  constructor(
    private router: Router,
    private _invoiceService: InvoiceService,
    private _storeService: StoreService,
    private _utilsService: UtilsService,
  ) {}

  async ngOnInit(): Promise<void> {
    const _data = JSON.parse(localStorage.getItem('data'));
    this.userCode = _data.userCode ? parseInt(_data.userCode.toString()) : 0;
    this.storeCode = _data.storeCode ? parseInt(_data.storeCode.toString()) : 0;

    await this.getStore(this.storeCode);
  }

  getStore(store: number): Promise<any> {
    return this._storeService.getOne(store).then(
      response => {
        if (response.result) {
          const storeData = response.records[0];
          this.establecimiento = storeData.storeEstablishmentCode          
            ? String(storeData.storeEstablishmentCode).padStart(3, '0')
            : '';
            this.punto = '001';
        } else {
          this._utilsService.showNotification(2, response.message || 'No se pudo obtener la sucursal');
        }
      },
      error => {
        console.log(error);
        this._utilsService.showNotification(2, 'Error al obtener la sucursal');
      }
    );
  }

  async sendInutilizacion(): Promise<void> {
    if (!this.establecimiento) {
      this._utilsService.showNotification(2, 'No se pudo determinar el establecimiento de la sucursal');
      return;
    }
    if (!this.punto) {
      this._utilsService.showNotification(2, 'Ingresa el punto de expedición');
      return;
    }
    if (!this.desde || !this.hasta) {
      this._utilsService.showNotification(2, 'Ingresa el rango de numeración (desde/hasta)');
      return;
    }
    if (Number(this.desde) > Number(this.hasta)) {
      this._utilsService.showNotification(2, 'El número inicial no puede ser mayor al número final');
      return;
    }
    if (!this.motivo || this.motivo.trim().length < 5) {
      this._utilsService.showNotification(2, 'El motivo debe tener al menos 5 caracteres');
      return;
    }

    this.loading = true;
    this.resultMessage = '';
    this.signedEventXml = '';
    this.dnitResponseRaw = '';
    this.lastRangeLabel = `${this.establecimiento}-${this.punto}-${this.desde}-${this.hasta}`;

    try {
      const body = {
        store: { storeCode: this.storeCode },
        user: { userCode: this.userCode },
        inutilizacion: {
          establecimiento: this.establecimiento,
          punto: this.punto,
          desde: this.desde,
          hasta: this.hasta,
          tipoDocumento: this.tipoDocumento,
          motivo: this.motivo.trim(),
          serie: this.serie ? this.serie.trim() : undefined,
        },
      };

      const response = await this._invoiceService.inutilizacionDnitPy(body);
      console.log('inutilizacionDnitPy response', response);

      this.resultMessage = response.message || (response.result ? 'Operación exitosa' : 'Error al inutilizar la numeración');

      const felData = response?.records?.felServiceResponse?.data || {};
      this.signedEventXml = felData.signedEventXml || '';
      this.dnitResponseRaw = felData.dnitResponseRaw || '';

      if (this.signedEventXml) {
        this.downloadXml(this.signedEventXml, `inutilizacion-enviado-${this.lastRangeLabel}.xml`);
      }
      if (this.dnitResponseRaw) {
        this.downloadXml(this.dnitResponseRaw, `inutilizacion-respuesta-${this.lastRangeLabel}.xml`);
      }

      swal.fire({
        title: response.result ? 'Éxito' : 'Error',
        text: this.resultMessage,
        icon: response.result ? 'success' : 'error',
        confirmButtonText: 'Aceptar',
        customClass: { confirmButton: response.result ? 'btn btn-success' : 'btn btn-danger' },
        buttonsStyling: false,
      });

      if (response.result) {
        this.clearForm();
      }
    } catch (error) {
      console.error('Error enviando inutilización a DNIT', error);
      const msg = typeof error === 'string' ? error : (error?.error?.message || 'Error al comunicarse con el servidor');
      swal.fire({
        title: 'Error',
        text: msg,
        icon: 'error',
        confirmButtonText: 'Aceptar',
        customClass: { confirmButton: 'btn btn-danger' },
        buttonsStyling: false,
      });
    } finally {
      this.loading = false;
    }
  }

  clearForm(): void {
    this.punto = '';
    this.desde = '';
    this.hasta = '';
    this.tipoDocumento = 'FACT';
    this.motivo = '';
    this.serie = '';
  }

  downloadXml(content: string, fileName: string): void {
    if (!content) return;

    const blob = new Blob([content], { type: 'application/xml' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    window.URL.revokeObjectURL(link.href);
  }
}
